import React, { useState } from 'react';
import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Row
} from 'react-bootstrap';
import styled from 'styled-components';
import LoadingButton from '../../../../components/ui/button/LoadingButton';
import '../../styles/login-inflo.css';

const ContinueButton = styled.div`
  text-align: 'center';
  margin-top: '15px';
  display: 'flex';
  justify-content: 'center';
`;

interface RegisterOnCategoryFirstStepProps {
  onSubmit: (email: string) => void;
  loading: boolean;
}

const RegisterOnCategoryFirstStep: React.FC<RegisterOnCategoryFirstStepProps> = ({
  onSubmit,
  loading
}) => {
  const [email, setEmail] = useState('');
  const [validationError, setValidationError] = useState('');

  const handleSubmit = () => {
    // Validate email format
    const emailPattern = /[a-z0-9._%+-]+@(asu\.edu|email\.asu\.edu)$/;
    if (!emailPattern.test(email.toLowerCase())) {
      setValidationError(
        'Please enter a valid email address ending with @asu.edu or @email.asu.edu'
      );
      return;
    }

    setValidationError('');
    onSubmit(email);
  };

  return (
    <>
      <Row>
        <Col xs={6} xsOffset={3}>
          <FormGroup controlId="email">
            <ControlLabel>Email</ControlLabel>
            <FormControl
              value={email}
              placeholder="e.g. user@asu.edu"
              componentClass="input"
              className="styleFieldLoginInflo"
              type="email"
              disable={loading.toString()}
              onChange={(e) => {
                setEmail(e.target.value);
                setValidationError('');
              }}
            />
            {validationError && (
              <span className="text-danger">{validationError}</span>
            )}
          </FormGroup>
        </Col>
      </Row>
      <ContinueButton>
        <LoadingButton
          isLoading={loading}
          onClick={handleSubmit}
          text="Continue"
          disabled={email === '' || validationError !== '' || loading}
        />
      </ContinueButton>
    </>
  );
};

export default RegisterOnCategoryFirstStep;
